
const Colors = {
    primary:'#02b9d3',
    secondary:'#f728c7',
    comlubiaBlue:'#CEEAF7',
    forestGreen:'#2B9720'
}


export default Colors